import environment from '~/platform/utilities/environment';
import recordEvent from '~/platform/monitoring/record-event';

const ERROR_SOURCES = Object.freeze({
  API: 'api',
  OTHER: 'other',
});

const createApiEvent = ({
  name = 'unknown',
  status = 'unknown',
  time,
  errorKey,
} = {}) => {
  const rv = {
    event: 'api_call',
    'api-name': name,
    'api-status': status,
  };
  if (time) {
    rv['api-latency-ms'] = time;
  }
  if (errorKey) {
    rv['error-key'] = errorKey;
  }
  return rv;
};

const captureError = (error, details) => {
  if (environment.isLocalhost()) {
    // eslint-disable-next-line no-console
    console.error({ error, details });
  }
};

const recordCustomProfileEvent = ({
  event = 'profile_modal',
  title = 'no title',
  status = 'none',
  primaryButtonText = 'none',
}) => {
  const payload = {
    event,
    'modal-title': title,
    'modal-status': status,
    'modal-primaryButtonText': primaryButtonText,
  };
  recordEvent(payload);
};

export {
  createApiEvent,
  captureError,
  ERROR_SOURCES,
  recordCustomProfileEvent,
};
